import React from 'react';
import PropTypes from 'prop-types';

import { StyledCard, StyledCardContent, Text, Checkbox } from '../../index';

const RulesCard = ({ rules, onSelect }) => {
    return (
        <StyledCard>
            <StyledCardContent style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                <Text $bold>Rules and Condition</Text>
                <StyledCard padding="48px 24px">
                    <StyledCardContent>
                        <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                            {rules.length > 0 &&
                                rules.map((rule) => (
                                    <div
                                        key={rule.id}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            columnGap: '10px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => onSelect(rule.id)}
                                    >
                                        <Checkbox
                                            checked={rules.find((r) => r.id === rule.id).checked}
                                            inputProps={{
                                                'aria-label': 'primary checkbox',
                                            }}
                                            style={{ padding: '5px' }}
                                        />
                                        <Text style={{ cursor: 'pointer' }}>{rule.text}</Text>
                                    </div>
                                ))}
                        </div>
                    </StyledCardContent>
                </StyledCard>
            </StyledCardContent>
        </StyledCard>
    );
};

RulesCard.propTypes = {
    rules: PropTypes.arrayOf(PropTypes.object),
    onSelect: PropTypes.func,
};

export default RulesCard;
